export * from './waitingForCall';
export * from './validation';
export * from './errorCaeOrAml';
export * from './exitModule';
export * from './allBenefits';
export * from './changeElectronicMail';

export const modals = {
	waitingForCall: 'waitingForCall',
	validation: 'validation',
	errorCaeOrAml: 'errorCaeOrAml',
	exitModule: 'exitModule',
	allBenefits: 'allBenefits',
	changeElectronicMail: 'changeElectronicMail',
};
